/**
 * Feature Flags Configuration
 *
 * Use these flags to enable/disable features without code changes.
 * For quick rollback, set a flag to false and redeploy frontend.
 */

export const FEATURE_FLAGS = {
  /**
   * Consolidated View on Forecast Page
   * When enabled, adds "Consolidated" as first option in location dropdown
   * Shows aggregated data across all 10 dealership locations
   */
  CONSOLIDATED_VIEW_ENABLED: true,

  /**
   * AI Chat Assistant
   * When enabled, shows AI Chat button in nav bar for Admin users.
   * Set to false to hide the feature without code changes.
   */
  AI_CHAT_ENABLED: true,
};
